<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#EE3231" fill-rule="nonzero">
        <g>
          <path
            d="M16.75 4.742L12.257.251C12.115.089 11.9 0 11.668 0H5.332c-.233 0-.448.09-.59.25L.25 4.743C.089 4.885 0 5.1 0 5.332v6.353c0 .215.09.43.25.573l4.492 4.491c.161.162.376.251.59.251h6.353c.215 0 .43-.09.59-.25l4.474-4.492c.162-.161.251-.376.251-.59V5.332c0-.233-.09-.448-.25-.59zM8.5 3.292c.68 0 1.235.573 1.199 1.271l-.233 4.653c-.018.519-.447.912-.966.912-.519 0-.93-.393-.966-.912L7.3 4.563c-.036-.698.519-1.27 1.199-1.27zm0 10.415c-.698 0-1.27-.572-1.27-1.27 0-.698.572-1.27 1.27-1.27.698 0 1.27.572 1.27 1.27 0 .698-.572 1.27-1.27 1.27z"
            transform="translate(-619 -207) translate(619 207)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>